import {useState, useEffect} from 'react'
import {Routes, Route, Outlet, Navigate, useLocation, useNavigate} from 'react-router-dom'
import {HeaderTabs} from './HeaderTabs'
import {useLayout} from '../../../_metronic/layout/core'
import SalesAndPurchaseView from './salesAndPurchase'
import ReceivablesAndPayables from './recievablesAndPayables'
export const Register = () => {
  const [activeTab, setActiveTab] = useState<string>('')
  const location = useLocation()
  // console.log(activeTab)
  const {company, financialYear, fyEndDate, fyStartDate} = useLayout()
  const navigate = useNavigate()
  useEffect(() => {
    if (!company || !company.value || !financialYear || !financialYear.value) {
      navigate('/companies')
    }
  }, [company.value, financialYear.value])

  useEffect(() => {
    const tab = location.pathname.split('/')[2]
    setActiveTab(tab)
  }, [location.pathname])
  return (
    <Routes>
      <Route
        element={
          <>
            <HeaderTabs setActiveTab={setActiveTab} />
            <Outlet />
          </>
        }
      >
        <Route
          path='sales'
          element={<SalesAndPurchaseView activeTab={activeTab} key={activeTab} />}
        />
        <Route
          path='purchase'
          element={<SalesAndPurchaseView activeTab={activeTab} key={activeTab} />}
        />
        <Route
          path='receivables'
          element={<ReceivablesAndPayables activeTab={activeTab} key={activeTab} />}
        />
        <Route
          path='payables'
          element={<ReceivablesAndPayables activeTab={activeTab} key={activeTab} />}
        />
        <Route
          path='creditnote'
          element={<SalesAndPurchaseView activeTab={activeTab} key={activeTab} />}
        />
        <Route
          path='debitnote'
          element={<SalesAndPurchaseView activeTab={activeTab} key={activeTab} />}
        />

        <Route index element={<Navigate to='/register/sales' />} />
      </Route>
      <Route path='*' element={<Navigate to='/error/404' />} />
    </Routes>
  )
}
